// extracted by css-extract-rspack-plugin
export default {"IncludeTargetIcon":"IncludeExcludeTarget-module__IncludeTargetIcon__AS7CSpR","ExcludeTargetIcon":"IncludeExcludeTarget-module__ExcludeTargetIcon__DUMU5Gg"};